module.exports = "<div class=score><span class=score__pre>Баллы:</span>&nbsp;<span class=score__value>{{value}}</span></div>";